import { createDayjsDate } from '@/utils/dayjs'
import { roundDecimalDigits } from '@/utils/currency'

export default {
  install (Vue) {
    Vue.filter('dateTimeFormat', (value, format = 'DD MMM YYYY') => (
      value ? createDayjsDate(value).locale('th').format(format) : value
    ))

    Vue.filter('numberComma', (value) => (value ? parseInt(value, 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : value))
    Vue.filter('price', (value) => (value ? roundDecimalDigits(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : value))
  }
}
